import React from "react";
import "./InteractionBar.css";
import { notEmpty } from "../../Infrastucture/MissingStd";

/* eslint-disable react/no-unused-prop-types */
export interface InteractionBarConfig {
  plays: number;
  echoes: number;
  comments: number;
  likes: number;

  associatedPostHref: string;
}
/* eslint-enable react/no-unused-prop-types */

export const demoProps1: InteractionBarConfig = {
  plays: 15455,
  echoes: 35,
  comments: 22,
  likes: 45,
  associatedPostHref: "/@sanjanasingh/a0f1eed2-d56a-4ed2-9cc9-fa03920a4f70",
};

function barComponent(
  count: number,
  visualComponent: JSX.Element,
  key: string
): JSX.Element | null {
  if (count === 0) {
    return null;
  }

  return (
    <div className="bar-component" key={key}>
      <span className="interaction-count">{count}</span>
      {visualComponent}
    </div>
  );
}

function playsIcon(): JSX.Element {
  return (
    <svg
      width="11"
      height="12"
      viewBox="0 0 11 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.15997 1.05858L9.19345 6.1221C9.38666 6.24388 9.37835 6.5283 9.17836 6.63859L1.14488 11.0692L1.48294 11.6821L1.14488 11.0692C0.944938 11.1795 0.7 11.0348 0.7 10.8065V1.31237C0.7 1.07623 0.960194 0.93266 1.15997 1.05858Z"
        stroke="#959595"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function sharesIcon(): JSX.Element {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1053 13.6995H1.80006V5.39424H6.2369L8.0369 3.59424H0.900056C0.410611 3.59424 0 3.98898 0 4.49429V14.5996C0 15.089 0.394737 15.4996 0.900056 15.4996H11.0053C11.4948 15.4996 11.9054 15.1049 11.9054 14.5996L11.9053 7.4785L10.1053 9.2785L10.1053 13.6995Z"
        fill="#7C7B7A"
      />
      <path
        d="M14.1001 0.500488H9.50537C9.00005 0.500488 8.60531 0.895225 8.60531 1.40054C8.60531 1.90586 9.00005 2.3006 9.50537 2.3006H11.9369L6.53689 7.7006C6.18953 8.04797 6.18953 8.61639 6.53689 8.96379C6.71058 9.13748 6.94739 9.23219 7.16842 9.23219C7.38946 9.23219 7.62625 9.13747 7.79994 8.96379L13.1999 3.56379V5.99531C13.1999 6.48475 13.5947 6.89536 14.1 6.89536C14.5894 6.89536 15 6.50063 15 5.99531V1.40057C15 0.895253 14.6053 0.500516 14.1 0.500516L14.1001 0.500488Z"
        fill="#7C7B7A"
      />
    </svg>
  );
}

function echoesIcon(): JSX.Element {
  return (
    <svg
      width="21"
      height="18"
      viewBox="0 0 21 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.198828 12.4581C0.198828 12.7895 0.467457 13.0581 0.798828 13.0581C1.1302 13.0581 1.39883 12.7895 1.39883 12.4581H0.198828ZM13.9979 2.77969C14.3292 2.77969 14.5979 2.51106 14.5979 2.17969C14.5979 1.84832 14.3292 1.57969 13.9979 1.57969V2.77969ZM1.39883 12.4581V8.17969H0.198828V12.4581H1.39883ZM6.79883 2.77969H13.9979V1.57969H6.79883V2.77969ZM1.39883 8.17969C1.39883 5.19735 3.81649 2.77969 6.79883 2.77969V1.57969C3.15375 1.57969 0.198828 4.53461 0.198828 8.17969H1.39883Z"
        fill="#7C7B7A"
      />
      <path
        d="M17.5143 1.9212C17.7118 2.03714 17.7118 2.32271 17.5143 2.43865L14.386 4.2749C14.186 4.39229 13.9341 4.24807 13.9341 4.01618L13.9341 0.34367C13.9341 0.11177 14.186 -0.0324434 14.386 0.0849467L17.5143 1.9212Z"
        fill="#7C7B7A"
      />
      <path
        d="M19.6273 4.90569C19.6273 4.57431 19.3587 4.30569 19.0273 4.30569C18.696 4.30569 18.4273 4.57431 18.4273 4.90569L19.6273 4.90569ZM5.82831 14.5841C5.49694 14.5841 5.22831 14.8527 5.22831 15.1841C5.22831 15.5155 5.49694 15.7841 5.82831 15.7841L5.82831 14.5841ZM18.4273 4.90569L18.4273 9.18409L19.6273 9.18409L19.6273 4.90569L18.4273 4.90569ZM13.0273 14.5841L5.82831 14.5841L5.82831 15.7841L13.0273 15.7841L13.0273 14.5841ZM18.4273 9.18409C18.4273 12.1664 16.0097 14.5841 13.0273 14.5841L13.0273 15.7841C16.6724 15.7841 19.6273 12.8292 19.6273 9.18409L18.4273 9.18409Z"
        fill="#7C7B7A"
      />
      <path
        d="M2.31187 15.4426C2.11435 15.3266 2.11435 15.0411 2.31187 14.9251L5.44021 13.0889C5.6402 12.9715 5.89208 13.1157 5.89208 13.3476L5.89208 17.0201C5.89208 17.252 5.6402 17.3962 5.44021 17.2788L2.31187 15.4426Z"
        fill="#7C7B7A"
      />
    </svg>
  );
}

function commentsIcon(): JSX.Element {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_1124_46655" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.90792 13.4468C1.82299 12.08 1.18456 10.406 1.18456 8.59772C1.18456 3.98767 5.33402 0.250488 10.4526 0.250488C15.5712 0.250488 19.7207 3.98767 19.7207 8.59772C19.7207 13.1804 15.6204 16.9005 10.5437 16.9446L0.799049 17.7495L2.90792 13.4468Z"
        />
      </mask>
      <path
        d="M2.90792 13.4468L4.00446 12.5764L4.55419 13.269L4.16504 14.063L2.90792 13.4468ZM10.5437 16.9446L10.4284 15.5493L10.4799 15.5451L10.5316 15.5446L10.5437 16.9446ZM0.799049 17.7495L0.914307 19.1448L-1.54342 19.3478L-0.458075 17.1334L0.799049 17.7495ZM2.58456 8.59772C2.58456 10.0668 3.10114 11.4384 4.00446 12.5764L1.81137 14.3172C0.544844 12.7216 -0.215441 10.7452 -0.215441 8.59772H2.58456ZM10.4526 1.65049C5.9658 1.65049 2.58456 4.89508 2.58456 8.59772H-0.215441C-0.215441 3.08026 4.70223 -1.14951 10.4526 -1.14951V1.65049ZM18.3207 8.59772C18.3207 4.89508 14.9395 1.65049 10.4526 1.65049V-1.14951C16.203 -1.14951 21.1207 3.08026 21.1207 8.59772H18.3207ZM10.5316 15.5446C14.9801 15.506 18.3207 12.2788 18.3207 8.59772H21.1207C21.1207 14.082 16.2606 18.295 10.5558 18.3445L10.5316 15.5446ZM0.683792 16.3543L10.4284 15.5493L10.6589 18.3398L0.914307 19.1448L0.683792 16.3543ZM4.16504 14.063L2.05617 18.3657L-0.458075 17.1334L1.65079 12.8307L4.16504 14.063Z"
        fill="#7C7B7A"
        mask="url(#path-1-inside-1_1124_46655)"
      />
    </svg>
  );
}

function likesIcon(): JSX.Element {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.6038 0.913086C16.9925 0.913086 18.3813 1.45695 19.4291 2.55373C21.525 4.74693 21.5223 8.26111 19.4291 10.4558L11.4292 18.8451V18.8453C11.282 18.9996 11.078 19.0871 10.8646 19.0871C10.6515 19.0871 10.4473 18.9996 10.3001 18.8453C7.63161 16.0526 4.96078 13.2567 2.29226 10.4639C0.196623 8.27066 0.196623 4.75463 2.29226 2.56181C4.38791 0.368612 7.84695 0.368426 9.94278 2.56181L10.8604 3.51212L11.7781 2.55387C12.8259 1.45727 14.2145 0.913221 15.6034 0.913221L15.6038 0.913086ZM15.6038 2.43985C14.6345 2.43985 13.6585 2.8394 12.8994 3.63381L11.4212 5.18508C11.274 5.33953 11.0701 5.42691 10.8567 5.42691C10.6435 5.42691 10.4396 5.33953 10.2924 5.18508L8.82233 3.64198C7.30424 2.05321 4.93957 2.05321 3.42126 3.64198C1.90317 5.23074 1.90317 7.80319 3.42126 9.39205C5.9007 11.9868 8.38144 14.5778 10.8606 17.1725L18.3 9.38416C19.8173 7.79321 19.818 5.22276 18.3 3.63409C17.5409 2.83971 16.573 2.44013 15.6035 2.44013L15.6038 2.43985Z"
        fill="#7C7B7A"
      />
    </svg>
  );
}

function rightIcons(props: InteractionBarConfig): JSX.Element {
  const { echoes, comments, likes } = props;

  const likesComponent = barComponent(likes, likesIcon(), "likes");
  const echoesComponent = barComponent(echoes, echoesIcon(), "echoes");
  const commentsComponent = barComponent(comments, commentsIcon(), "comments");

  const visibleComponents = [
    echoesComponent,
    commentsComponent,
    likesComponent,
  ].filter(notEmpty);

  return <span className="right-icons">{visibleComponents}</span>;
}

function leftIcons(props: InteractionBarConfig): JSX.Element {
  const { plays } = props;

  return (
    <div className="left-icons">
      {barComponent(plays, playsIcon(), "plays")}
      <span>{sharesIcon()}</span>
    </div>
  );
}

export function InteractionBar(props: InteractionBarConfig): JSX.Element {
  return (
    <a href={props.associatedPostHref}>
      <div className="interaction-bar">
        <div className="left-icons">{leftIcons(props)}</div>
        <div className="right-icons">{rightIcons(props)}</div>
      </div>
    </a>
  );
}
